import {testIdProps} from '@github-ui/test-id-props'
import {Label} from '@primer/react'

import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './default-group-header-label.module.css'

type Props = {
  titleHtml: string
  label?: string
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

/**
 * This is our default group header for situations where we don't have access
 * to any "rich" model for rendering the header
 */
export function DefaultGroupHeaderLabel({
  titleHtml,
  label,
  rowCount,
  hideItemsCount,
  aggregates,
  titleClassName,
}: Props) {
  return (
    <>
      <SanitizedGroupHeaderText titleHtml={titleHtml} className={titleClassName} />
      {label && (
        <Label className={styles.Label} {...testIdProps(`table-group-label`)}>
          {label}
        </Label>
      )}
      <AggregateLabels
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
        counterClassName={styles.AggregateLabels}
      />
    </>
  )
}

try{ DefaultGroupHeaderLabel.displayName ||= 'DefaultGroupHeaderLabel' } catch {}